export default (props)=>{
    const { getBlock } = wp.data.select( "core/block-editor" );
    const { getBlockContent  } = wp.blocks;
    const innerContent = getBlockContent( getBlock(  props.clientId ) );
    const  ServerSideRender  = wp.serverSideRender;

    if(!props.clientId){
        console.error('ServerSideRenderAvecInnerBlocks a besoins du props clientid');
        return null;
    }
    if(!props.metadata){
        console.error('ServerSideRenderAvecInnerBlocks a besoins du props metadata');
        return null;
    }

    return <ServerSideRender block={props.metadata.name} attributes={ {...props.attributes,innerContent} } />
}